import { Button, Modal, Upload, message, Progress, Spin, Divider } from "antd";
import ImgCrop from "antd-img-crop";

import { PixelCrop } from "react-image-crop";

import { useEffect, useState, useRef } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../appRedux/actions/CoreServicesAction";

import Url from "../../apiCall/UrlConfig";
import { useNavigate } from "react-router-dom";

import ReactCrop from "react-image-crop";
import axios from "axios";

import "react-image-crop/dist/ReactCrop.css";
import { useDebounceEffect } from "../../component/debuance";

const DentalCaries = (props) => {
  let navigation = useNavigate();
  const [fileList, setFileList] = useState([
    // {
    //   uid: "-1",
    //   name: "image.png",
    //   status: "done",
    //   url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    // },
  ]);

  const [fileListCeplhalo, setFileListfileListCeplhalo] = useState([]);
  const [fileListOpg, setFileListfileListOpg] = useState([]);

  let lateralScale = 0.6;
  const [_showModalProcess, setShowModalProcess] = useState(false);
  const [_progresPrecent, setProgresPrecent] = useState(0);
  const [_selectFile, setselectFile] = useState(null);

  const [reportedFile, setReportedFile] = useState(null);
  const [processType, setProcessType] = useState(null);

  let [loadingSegment, setLoading] = useState(false);

  const [cropModalVisible, setCropModalVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({
    unit: "%", // Can be 'px' or '%'
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });
  const [completedCrop, setCompletedCrop] = useState(null);
  const imgRef = useRef(null);
  const [cropImage, setCropImage] = useState(null);

  const [rotation, setRotation] = useState(0);
  const previewCanvasRef = useRef();

  const [Uploading, setUploading] = useState(false);
  const [uploadprogress, setuploadprogress] = useState(0);

  const onChange = (info) => {
    let newFileList = info?.fileList;

    setFileList(newFileList);

    if (info?.file?.status === "done") {
      console.log("info sucess", info);
      _prosessImage(info.file);
    }

    if (info?.file?.status === "error") {
      setFileList([]);
      message.error(info?.file?.response?.message);
      console.log("info error", info);
    }
  };

  const onPreview = async (file) => {};
  const onPreviewOpg = async (file) => {
    window.open(
      Url.baseURL + Url.dental_file_donwload + file.response.traceMessage
    );
  };

  const onChangeCephalo = (info) => {
    let newFileList = info?.fileList;

    setFileListfileListCeplhalo(newFileList);

    if (info.file.status === "done") {
      console.log("info sucess", info);
      _prosessImageChephalo(info?.file);
    }

    if (info.file.status === "error") {
      setFileListfileListCeplhalo([]);
      message.error(info?.file?.response?.message);
      console.log("info error", info);
    }
  };

  const onChangeOpg = (info) => {
    let newFileList = info?.fileList;

    setFileListfileListOpg(newFileList);

    if (info.file.status === "done") {
      console.log("info sucess", info);
      _processImageOpg(info?.file);
    }

    if (info.file.status === "error") {
      setFileListfileListOpg([]);
      message.error(info?.file?.response?.message);
      console.log("info error", info);
    }
  };

  const _processImageOpg = async (file) => {
    if (file.response.id <= 0) {
      message.error("Error");
      return;
    }
    setProcessType("opg");

    setLoading(true);
    setShowModalProcess(true);

    let fileName = file.response.traceMessage;

    let url = Url.opgPredictSegment + fileName;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    setLoading(false);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    setReportedFile(JSON.parse(res.data));
  };
  const _prosessImageChephalo = (file) => {
    navigation("/publiclateralchephalo/" + file?.response?.traceMessage);
  };

  const _prosessImage = async (file) => {
    if (file.response.id <= 0) {
      message.error("Error");
      return;
    }

    setProcessType("photography");

    setLoading(true);
    setShowModalProcess(true);

    let fileName = file.response.traceMessage;

    let url = Url.photographyseeSegment + fileName;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    setLoading(false);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    setReportedFile(JSON.parse(res.data));
  };
  function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  const ProcessColorInfoOpg = () => {
    return (
      <div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ width: 30, height: 20, backgroundColor: "red" }}></div>
          <div>Caries</div>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{ width: 30, height: 20, backgroundColor: "green" }}
          ></div>
          <div>Implant</div>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ width: 30, height: 20, backgroundColor: "blue" }}></div>
          <div>RCT</div>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{ width: 30, height: 20, backgroundColor: "yellow" }}
          ></div>
          <div>Filling</div>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{ width: 30, height: 20, backgroundColor: "#00FFFF" }}
          ></div>
          <div>post</div>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{ width: 30, height: 20, backgroundColor: "#FF00FF" }}
          ></div>
          <div>Periapical Lesion</div>
        </div>
      </div>
    );
  };

  const handleBeforeUpload = (file) => {
    if (!file.type.startsWith("image/")) {
      message.error("فقط تصاویر قابل بارگزاری هستند!");
      return false;
    }
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setImageSrc(reader.result);
      setSelectedFile(file);
      setCropModalVisible(true);
    });
    reader.readAsDataURL(file);
    // Prevent auto upload
    return false;
  };

  // When the image is loaded in the crop component
  const onImageLoaded = (image) => {
    imgRef.current = image;
  };

  // Create the cropped image blob using canvas

  // Handle the crop confirmation
  const handleCrop = async () => {
    if (!completedCrop || !imgRef.current) {
      message.error("please Crop");
      return;
    }
    try {
      const croppedBlob = await getCroppedImg(imgRef.current, completedCrop, 0);
      // Create a new File from the cropped blob
      const croppedFile = new File([croppedBlob], selectedFile.name, {
        type: selectedFile.type,
      });

      const formData = new FormData();
      formData.append("file", croppedFile, croppedFile.name); // 'file' should match the server key

      try {
        setUploading(true);

        const response = await axios.post(
          Url.baseURL + Url.file_upload_dental,
          formData,
          {
            onUploadProgress: (progressEvent) => {
              const percentComplete = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setuploadprogress(percentComplete);
            },
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("Upload success:", response.data);

        let files = {};
        files.response = response.data;
        _prosessImage(files);
      } catch (error) {
        console.error("Error uploading file:", error);
      }

      setUploading(false);
      setuploadprogress(0);

      // Update the file list (or upload immediately if desired)
      setFileList((prev) => []);

      // Reset state and close modal
      setCropModalVisible(false);
      setImageSrc(null);
      setSelectedFile(null);
      setCrop({ unit: "%", width: 50, height: 50, x: 0, y: 0 });
      setCompletedCrop(null);
    } catch (error) {
      console.error(error);
      message.error("خطا در برش تصویر!");
    }
  };

  const getCroppedImg = async () => {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error("Crop canvas does not exist");
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );
    const ctx = offscreen.getContext("2d");
    if (!ctx) {
      throw new Error("No 2d context");
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height
    );
    // You might want { type: "image/jpeg", quality: <0 to 1> } to
    // reduce image size
    const blob = await offscreen.convertToBlob({
      type: "image/png",
    });

    return blob;
  };

  const TO_RADIANS = Math.PI / 180;

  async function canvasPreview(image, canvas, crop, scale = 1, rotate = 0) {
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      throw new Error("No 2d context");
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    // devicePixelRatio slightly increases sharpness on retina devices
    // at the expense of slightly slower render times and needing to
    // size the image back down if you want to download/upload and be
    // true to the images natural size.
    const pixelRatio = window.devicePixelRatio;
    // const pixelRatio = 1

    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;

    const rotateRads = rotate * TO_RADIANS;
    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;

    ctx.save();

    // 5) Move the crop origin to the canvas origin (0,0)
    ctx.translate(-cropX, -cropY);
    // 4) Move the origin to the center of the original position
    ctx.translate(centerX, centerY);
    // 3) Rotate around the origin
    ctx.rotate(rotateRads);
    // 2) Scale the image
    ctx.scale(scale, scale);
    // 1) Move the center of the image to the origin (0,0)
    ctx.translate(-centerX, -centerY);
    ctx.drawImage(
      image,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight
    );

    ctx.restore();
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          1,
          rotation
        );
      }
    },
    100,
    [completedCrop, rotation]
  );
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: "url(/image/dental/bg.jpg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        color: "white",
        ////relative
        position: "relative",
      }}
    >
      <Modal
        open={_showModalProcess}
        onCancel={() => {
          setShowModalProcess(false);
          setReportedFile(null);
        }}
        onOk={() => setShowModalProcess(false)}
        footer={null}
      >
        <div style={{ textAlign: "center" }}>
          {loadingSegment ? "در حال پردازش" : "پردازش انجام شد"}
        </div>
        <div style={{ textAlign: "center" }}>{loadingSegment && <Spin />}</div>
        {processType == "opg" && <ProcessColorInfoOpg />}

        {reportedFile != null && loadingSegment != true && (
          <div>
            <img
              style={{
                width: "100%",
                // height: 120,
                borderRadius: 15,
                marginTop: 5,
                marginLeft: 10,
              }}
              src={
                Url.baseURL + Url.dental_file_donwload + reportedFile.imageName
              }
              alt="image"
              onClick={() => {
                window.open(
                  Url.baseURL +
                    Url.dental_file_donwload +
                    reportedFile.imageName
                );
              }}
            />
          </div>
        )}
        {/* <div>{_selectFile?.response.traceMessage}</div> */}
      </Modal>
      <Modal
        open={cropModalVisible}
        onOk={handleCrop}
        onCancel={() => setCropModalVisible(false)}
        okText="crop and upload"
        okButtonProps={{ loading: Uploading }}
        cancelText="cancel"
        destroyOnClose
      >
        {imageSrc && (
          <>
            <ReactCrop
              src={imageSrc}
              crop={crop}
              onImageLoaded={onImageLoaded}
              onChange={(_, newCrop) => setCrop(newCrop)}
              onComplete={(c) => setCompletedCrop(c)}
              minHeight={20}
            >
              <img
                ref={imgRef}
                alt="Crop me"
                src={imageSrc}
                style={{
                  transform: `rotate(${rotation}deg)`, // 🔥 Apply rotation dynamically
                  transition: "transform 0.1s ", // Smooth effect
                }}
              />
            </ReactCrop>
          </>
        )}

        <div className="rotation-slider-container">
          <div className="slider-wrapper">
            {/* Range Input */}
            <input
              type="range"
              min="-45"
              max="45"
              step="1"
              value={rotation}
              onChange={(e) => setRotation(Number(e.target.value))}
              className="rotation-slider"
            />

            {/* The center label that shows the current angle */}
            <div className="angle-label">{rotation}°</div>
          </div>
        </div>

        {!!completedCrop && (
          <div style={{ display: "none" }}>
            previewCanvasRef
            <canvas
              ref={previewCanvasRef}
              style={{
                border: "1px solid black",
                objectFit: "contain",
                width: completedCrop.width,
                height: completedCrop.height,
              }}
            />
          </div>
        )}

        <div>
          uploading
          <Progress percent={uploadprogress} showInfo={false} />
        </div>
      </Modal>

      <div style={{ color: "white", textAlign: "center", fontSize: 25 }}>
        Dental Ai System
      </div>
      <div style={{ textAlign: "center" }}>one image with this type upload</div>
      <div style={{ textAlign: "center" }}>
        <img
          style={{
            // width: 120,
            // height: 120,
            borderRadius: 15,
            marginTop: 5,
            marginLeft: 10,
          }}
          src={"/image/dental/maxila.png"}
          alt="image"
        />
      </div>
      <div style={{ textAlign: "center" }}>
        <img
          style={{
            // width: 120,
            // height: 120,
            borderRadius: 15,
            marginTop: 5,
            marginLeft: 10,
          }}
          src={"/image/dental/mandible.png"}
          alt="image"
        />
      </div>
      <div style={{ textAlign: "center" }}>upload</div>
      <div style={{ textAlign: "center" }}>
        <Upload
          action={Url.baseURL + Url.file_upload_dental}
          listType="picture-card"
          fileList={fileList}
          beforeUpload={handleBeforeUpload}
          // onChange={onChange}
          onPreview={onPreview}
        >
          {fileList.length < 5 && " upload"}
        </Upload>
        {/* <ImgCrop
          rotate
          showReset
          showGrid
          modalTitle="Crop your image"
          modalWidth={800}
          fillColor="transparent" // Keeps transparent background
          quality={1}
          cropShape="rect" // Allows cropping in a rectangular shape
          zoom
          aspect={undefined}
        >
          <Upload
            action={Url.baseURL + Url.file_upload_dental}
            listType="picture-card"
            fileList={fileList}
            onChange={onChange}
            onPreview={onPreview}
          >
            {fileList.length < 5 && "+ بارگزاری تصویر"}
          </Upload>
        </ImgCrop> */}
      </div>
      <div
        style={{
          width: "100%",
          borderTopWidth: 1,
          height: 5,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderBottomWidth: 0,
          borderStyle: "solid",
          borderColor: "white",
        }}
      />
      <div className="text-center white-text title-fontsize">
        lateral cephalometric Analysis
      </div>
      <div className="text-center">one image with this type upload</div>
      <div style={{ textAlign: "center" }}>
        <img
          style={{
            maxWidth: 200,
            marginBottom: 50,
          }}
          src={"/image/dental/lateralcephalo.jpeg"}
          alt="lateralchephalo"
        />
      </div>
      <div className="text-center">upload Lateral Cephalo</div>
      <div className="text-center">
        {/* <ImgCrop rotationSlider aspectSlider> */}
        <Upload
          action={Url.baseURL[0] + Url.file_upload_dental}
          listType="picture-card"
          fileList={fileListCeplhalo}
          onChange={onChangeCephalo}
          onPreview={onPreview}
        >
          {fileList.length < 5 && "+ upload Lateral Cephalo"}
        </Upload>
        {/* </ImgCrop> */}
      </div>
      <div
        style={{
          width: "100%",
          borderTopWidth: 1,
          height: 5,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderBottomWidth: 0,
          borderStyle: "solid",
          borderColor: "white",
        }}
      />
      <div className="text-center white-text title-fontsize">
        Panoramic Radiography Analysis
      </div>
      <div className="text-center">one image with this type upload</div>
      <div style={{ textAlign: "center" }}>
        <img
          style={{
            maxWidth: 500,
            marginBottom: 50,
            width: "100%",
          }}
          src={"/image/dental/opg.png"}
          alt="lateralchephalo"
        />
      </div>
      <div className="text-center">Upload Opg</div>
      <div className="text-center">
        {/* <ImgCrop rotationSlider aspectSlider> */}
        <Upload
          action={Url.baseURL[0] + Url.file_upload_dental}
          listType="picture-card"
          fileList={fileListOpg}
          onChange={onChangeOpg}
          onPreview={onPreviewOpg}
        >
          {fileList.length < 5 && "+  Upload Opg"}
        </Upload>
        {/* </ImgCrop> */}
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(DentalCaries);
